import { useEffect, useState } from "react";

import { INiche } from "services/types";
import { useNichesQuery } from "queries";
import { CheckButton } from "components/buttons";
import { Image } from "components";

import "./NicheSelector.scss";

export const NicheSelector = (props: {
  selected: string[];
  onChange: (values: string[]) => void;
}): JSX.Element => {
  const [niches, setNiches] = useState<INiche[]>([]);

  const query = useNichesQuery({
    order: "name",
    previews: false,
  });

  useEffect(() => {
    if (query.isSuccess && query.data) {
      setNiches(query.data.niches);
      console.debug(`Loaded ${query.data.niches.length} niches.`);
    }
  }, [query.isSuccess, query.data]);

  const ordered = () => {
    const part1 = niches.filter(x => props.selected.indexOf(x.id) >= 0);
    const part2 = niches.filter(x => props.selected.indexOf(x.id) < 0);
    return [...part1, ...part2];
  };

  const handleClick = (id: string) => () => {
    let values = [];

    if (props.selected.indexOf(id) >= 0) {
      values = props.selected.filter(x => x !== id);
    } else {
      values = [...props.selected, id];
    }

    props.onChange(values);
  };

  return (
    <div className="nicheSelector">
      {ordered().map((el: INiche, index: number) => (
        <div className="row" key={index}>
          <Image src={el.thumbnail} />

          <div className="name">{el.name}</div>

          <CheckButton
            onClick={handleClick(el.id)}
            checked={props.selected.indexOf(el.id) >= 0}
          />
        </div>
      ))}
    </div>
  );
};
